import { defineMessages } from 'react-intl';

export default defineMessages({
    generalCoverages: {
        id: 'gw-portals-bop-components-angular.coverages.general.generalCoverages.General Coverages',
        defaultMessage: 'General Coverages',
    }
});
